import { render } from "./download.vue?vue&type=template&id=914ea2b2&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"

import "./download.vue?vue&type=style&index=0&id=914ea2b2&lang=less&scoped=true"

import exportComponent from "D:\\2018 -2020 工作\\2020 中创\\Projects\\frontend\\publicity\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-914ea2b2"]])

export default __exports__